<template>
    <flex-container>
        <!-- @todo: size might need to be changed after changes to flex-container -->
        <flex-container :size="3">
            <div>
                <text-heading sub>
                    Automations
                </text-heading>
            </div>
        </flex-container>

        <!-- @todo: size might need to be changed after changes to flex-container -->
        <flex-container :size="1" style="justify-content: end">
            <input-group :model-value="'Huidig'">
                <template #input>
                    <select-input
                        :items="[
                            'Huidig',
                        ]"
                    />
                </template>
            </input-group>
        </flex-container>
    </flex-container>

    <chip-container>
        <chip-label
            v-for="automation in automations"
            :key="automation"
            :color="Color.orange500"
        >
            {{ automation }}
        </chip-label>
    </chip-container>
</template>

<script setup lang="ts">
    import {
        ChipContainer,
        ChipLabel,
        FlexContainer,
        TextHeading,
        Color,
        InputGroup,
        SelectInput,
    } from '@keyvue/one-ui';

    import { computed } from 'vue';

    const automations = computed(() => [
        'Direct na bezichtiging',
        'Longwail-waardebepaling',
    ]);
</script>
